import { useMapEvents } from 'react-leaflet';

export default function ClickHandler({ onClick, enabled }) {
  useMapEvents({
    click(e) {
      if (enabled) {
        const { lat, lng } = e.latlng;
        onClick({ x: lng, y: lat });
      }
    }
  });
  return null;
}
